import React from 'react';
import proptypes from 'prop-types';
import { AlertMessage } from './alertMessage';

const { bool } = proptypes;

export const Alerts = (
  {
    showAlerts = false,
    jumpedState = false,
    impossibleState = false,
    showSelectionChangeWarning = false
  }
) => {
  if (!showAlerts && !showSelectionChangeWarning) return null;

  return (
    <>
      {showAlerts && jumpedState && (
        <AlertMessage message="Your selections have been updated based on availability." />
      )}
      {showAlerts && impossibleState && (
        <AlertMessage message="We had some trouble loading your options. Select any option to get started." />
      )}
      {!showAlerts && showSelectionChangeWarning && (
        <AlertMessage
          type="info"
          message="We updated your selection based on the available options."
        />
      )}
    </>
  );
};

Alerts.displayName = 'SuperSkuAlerts';

Alerts.propTypes = {
  showAlerts: bool,
  jumpedState: bool,
  impossibleState: bool,
  showSelectionChangeWarning: bool
};
